{
  "common": {
    "admin_settings": "Admin Settings",
    "back": "← Back",
    "delete": "Delete",
    "edit": "Edit",
    "cancel": "Cancel",
    "select": "Select",
    "close": "Close",
    "dismiss": "Dismiss",
    "scroll_left": "Scroll Left",
    "scroll_right": "Scroll Right"
  },
  "language": {
    "switcher_label": "Language"
  },
  "wine_color": {
    "red": "Red",
    "white": "White",
    "rose": "Rosé",
    "orange": "Orange",
    "unknown": "Wine"
  },
  "wine_style": {
    "sparkling": "Sparkling",
    "sweet": "Sweet",
    "fortified": "Fortified"
  },
  "display_category": {
    "sparkling": "Sparkling",
    "white": "White",
    "orange": "Orange",
    "rose": "Rosé",
    "red": "Red",
    "dessert": "Dessert"
  },
  "cuisine": {
    "italian": "Italian",
    "french": "French",
    "japanese": "Japanese",
    "chinese": "Chinese",
    "middle_eastern": "Middle Eastern"
  },
  "course": {
    "starter": "Starter",
    "main": "Main",
    "dessert": "Dessert"
  },
  "dietary_tag": {
    "vegetarian": "Vegetarian",
    "vegan": "Vegan",
    "gluten_free": "Gluten Free"
  },
  "taste_axis": {
    "taste_sweetness": "Sweetness",
    "taste_acidity": "Acidity",
    "taste_saltiness": "Saltiness",
    "taste_bitterness": "Bitterness",
    "taste_umami": "Umami",
    "taste_richness": "Richness",
    "taste_spice_heat": "Spice Heat"
  },
  "wine_filters": {
    "sommelier_picks": "Sommelier's Picks",
    "sommelier_picks_singular": "Sommelier's Pick",
    "type": "Type",
    "price_view": "Price view",
    "by_bottle": "By Bottle",
    "by_glass": "By Glass",
    "max_price": "Max Price",
    "region": "Region",
    "bottle_size": "Bottle size"
  },
  "wine_card": {
    "bottle": "Bottle",
    "glass": "Glass"
  },
  "dish_card": {
    "chefs_special": "Chef's Special",
    "plate": "Plate"
  },
  "dish_filters": {
    "chefs_choice": "Chef's Choice",
    "cuisine": "Cuisine",
    "course": "Course",
    "dietary": "Dietary",
    "delete_all": "Delete all",
    "dish_count_one": "{{count}} dish",
    "dish_count_other": "{{count}} dishes"
  },
  "home": {
    "page_title": "Wine list",
    "tab_drinks": "Drinks",
    "tab_dishes": "Dishes",
    "map_view": "Map view",
    "wine_count_one": "{{count}} wine",
    "wine_count_other": "{{count}} wines",
    "dish_count_one": "{{count}} dish",
    "dish_count_other": "{{count}} dishes",
    "no_wines_match": "No wines match these filters.",
    "no_dishes_yet": "No dishes on the menu yet.",
    "no_dishes_match": "No dishes match these filters."
  },
  "map": {
    "page_title": "Cellar Map | Wine Atlas - Perfect Pairings",
    "map_view_title": "Map View",
    "wine_selection": "Wine Selection",
    "our_cellar": "Our Cellar",
    "wines_lowercase": "wines",
    "full_view": "Full View",
    "sommelier_picks_only": "Sommelier's Picks Only",
    "max_price": "Max Price",
    "click_pin_to_filter": "Click a pin on the map to filter",
    "show_less": "Show less",
    "more_regions_one": "+{{count}} more region",
    "more_regions_other": "+{{count}} more regions",
    "no_wines_in_view": "No wines in the current map view.",
    "pan_or_zoom_out": "Pan or zoom out to include more locations.",
    "no_wines_match_selection": "No wines match the current selection.",
    "zoom_out": "Zoom Out",
    "show_details": "Show details",
    "winery_fallback": "Winery"
  },
  "wine_show": {
    "page_title": "{{name}} | Wine Atlas - Perfect Pairings",
    "established": "Est. {{year}}",
    "sommelier_choice_line1": "SOMMELIER'S",
    "sommelier_choice_line2": "CHOICE",
    "tasting_notes": "Tasting notes",
    "per_glass": "Per glass",
    "per_bottle": "Per bottle",
    "vintage": "Vintage",
    "origin": "Origin",
    "grape_variety": "Grape variety",
    "tasting_profile": "Tasting profile",
    "acidity": "Acidity",
    "body": "Body",
    "tannin": "Tannin",
    "sweetness": "Sweetness",
    "paired_selection": "Paired selection",
    "no_pairings_yet": "No pairing dishes available for this wine yet.",
    "pairing_dish_fallback": "Pairing dish",
    "pairing_tag": "PAIRING",
    "untitled": "Untitled",
    "winery_location": "Winery location",
    "estate_size": "Estate size",
    "founded": "Founded",
    "about_winery": "About the winery",
    "winery_fallback": "Winery",
    "highlight_fallback": "Highlight"
  },
  "dish_show": {
    "page_title": "{{title}} | Wine Atlas - Perfect Pairings",
    "chefs_special_line1": "CHEF'S",
    "chefs_special_line2": "SPECIAL",
    "sommelier_pick_line1": "SOMMELIER'S",
    "sommelier_pick_line2": "PICK",
    "price": "Price",
    "taste_profile": "Taste profile",
    "wine_count_one": "{{count}} wine",
    "wine_count_other": "{{count}} wines",
    "no_pairings_yet": "No pairing wines available for this dish yet.",
    "pairing_wine_fallback": "Pairing wine",
    "ingredients": "Ingredients"
  },
  "landing": {
    "meta_title": "Perfect Pairings — The Wine List Reimagined",
    "meta_description": "An interactive, map-driven digital wine experience for fine dining restaurants.",
    "sign_in": "Sign in",
    "book_demo": "Book a demo",
    "hero": {
      "eyebrow": "Now available · Free trial",
      "title_line1": "The Wine List",
      "title_line2": "Reimagined",
      "subtitle": "An interactive, map-driven digital wine experience for fine dining restaurants. Elevate your cellar. Inspire your guests. Sell more wine.",
      "start_trial": "Start your free trial",
      "see_how": "See how it works",
      "scroll_aria": "Scroll to how it works"
    },
    "why": {
      "label": "Why restaurants choose us",
      "title": "Why Perfect Pairings",
      "subtitle": "Everything you need to present your cellar with confidence — from first upload to the guest's glass."
    },
    "features": {
      "discover": {
        "kicker": "Discover",
        "title": "Interactive Wine Map",
        "body": "Guide your guests through wine regions with a stunning interactive map — turning a simple choice into a journey."
      },
      "control": {
        "kicker": "Control",
        "title": "Effortless Management",
        "body": "Upload, edit and curate your entire wine collection from one elegant dashboard. Changes go live instantly."
      },
      "enrich": {
        "kicker": "Enrich",
        "title": "Digital Sommelier",
        "body": "Each wine is automatically enriched with tasting profiles, winery stories, and expert notes — no manual effort required."
      }
    },
    "workflow": {
      "label": "Your workflow",
      "title": "Everything your cellar deserves",
      "subtitle": "A clear path from list to guest — built for busy dining rooms and meticulous sommeliers alike."
    },
    "steps": {
      "step_label": "Step {{number}}",
      "upload": {
        "title": "Upload your wine list",
        "body": "CSV, Excel or manual entry. Each wine is automatically enriched with descriptions, tasting notes, and winery stories.",
        "extra": "CSV, Excel, PDF, or image — AI will extract the wines automatically",
        "image_alt": "Wine list and tasting experience"
      },
      "share": {
        "title": "Share with your guests",
        "body": "A single link or QR code. Guests explore your wines on an interactive world map, from their table.",
        "image_alt": "Vineyard landscape"
      },
      "customise": {
        "title": "Customise your cellar",
        "body": "Set sommelier's picks, add photos, fine-tune tasting profiles. Your list, your curation.",
        "image_alt": "Wine cellar"
      }
    },
    "testimonials_section": {
      "label": "Trusted by teams",
      "title": "Early adopters"
    },
    "testimonials": {
      "maison_doree": {
        "quote": "Our guests now spend twice as long exploring the wine list. It has transformed the way we sell bottles.",
        "role": "F&B Director, Maison Dorée"
      },
      "osteria_fina": {
        "quote": "The map view is extraordinary. It creates a conversation between our team and the guest before a single word is spoken.",
        "role": "Head Sommelier, Osteria Fina"
      }
    },
    "cta": {
      "title": "Get started today",
      "body1": "We're currently onboarding a select group of restaurants. Book a personal demo and we'll set up your wine list together — live, in under an hour.",
      "body2": "Join our trial programme and bring a new dimension to your wine service. No risk, no obligation — just a better wine experience for your guests.",
      "contact_us": "Contact us",
      "footer_line": "Set up your profile and start building your digital wine list"
    },
    "footer": {
      "copyright": "© 2026 Perfect Pairings. All rights reserved."
    }
  },
  "manager_nav": {
    "restaurant_admin": "Restaurant Admin",
    "manage_wines": "Manage Wines",
    "manage_dishes": "Manage Dishes",
    "start_pairing": "Start Pairing",
    "customer_view": "Customer View",
    "log_out": "Log out"
  },
  "manager_common": {
    "your_restaurant": "Your restaurant",
    "logo_alt": "{{name}} logo"
  },
  "restaurant_admin": {
    "page_title": "{{name}} Admin | Wine Atlas - Perfect Pairings",
    "restaurant_fallback": "Restaurant",
    "eyebrow": "Restaurant Management",
    "public_menu_link": "Public Menu Link",
    "public_menu_link_description": "Share this with guests, or print it as a QR code for the table — no login required.",
    "copied": "Copied!",
    "copy_link": "Copy link",
    "upload_logo": "Upload Logo",
    "logo_hint": "PNG, JPG up to 5MB",
    "restaurant_name": "Restaurant Name",
    "restaurant_name_placeholder": "e.g. La Maison du Vin",
    "description": "Description",
    "description_placeholder": "Tell guests about your restaurant and wine philosophy...",
    "language": "Language",
    "language_hint": "Drives every guest-facing page and your own manager screens. Guests can still switch language for themselves on the public menu.",
    "creating": "Creating...",
    "saving": "Saving...",
    "create_restaurant": "Create Restaurant",
    "save_changes": "Save changes",
    "sections": {
      "general": {
        "title": "General Settings",
        "subtitle": "Restaurant name, description and contact details"
      },
      "guided_selling": {
        "title": "Guided Selling",
        "subtitle": "Help your floor staff pick the right wine for any dish"
      },
      "placeholder_images": {
        "title": "Placeholder Images",
        "subtitle": "Default images shown when no photo is uploaded"
      },
      "subscriptions": {
        "title": "Subscriptions",
        "subtitle": "Manage active modules and add-ons"
      }
    },
    "guided_selling": {
      "intro": "Guided selling ranks wine pairings purely on taste -- price never enters that step. This dial only controls how much the ladder afterwards, per price band, may let margin decide between wines that already match equally well.",
      "open_link": "Open Guided Selling"
    },
    "margin_depth": {
      "pure_taste": "Pure taste",
      "pure_taste_description": "Best taste match always wins.",
      "light_steer": "Light steer",
      "light_steer_description": "Margin breaks a tied taste score.",
      "active_steer": "Active steer",
      "active_steer_description": "Deliberately trade some taste for margin."
    },
    "placeholders": {
      "winery_banner": "Winery Banner",
      "uploaded": "Uploaded",
      "system_default": "System Default",
      "custom": "Custom",
      "landscape_hint": "Landscape panoramic photo",
      "portrait_hint": "Portrait bottle image",
      "no_image": "No Image",
      "uploading": "Uploading...",
      "replace_image": "Replace Image",
      "upload_image": "Upload Image"
    },
    "subscriptions": {
      "no_modules": "No modules are currently available. Ask your admin to publish package plans.",
      "monthly_price": "Monthly: {{price}}",
      "yearly_price": "Yearly: {{price}}",
      "yearly_savings": "Save about {{percent}}% yearly",
      "request_in_progress": "Request in Progress",
      "active": "Active",
      "billing_fallback": "billing",
      "date_range": "{{start}} to {{end}}",
      "cancelling": "Cancelling…",
      "cancel_subscription": "Cancel subscription",
      "enable_hint": "Enable this module to choose a billing cycle and subscribe.",
      "modal_title": "{{title}} billing",
      "modal_subtitle": "Choose how you want to be billed.",
      "yearly": "Yearly",
      "monthly": "Monthly",
      "yearly_savings_full": "Save about {{percent}}% vs monthly for a full year.",
      "due_today": "Due today",
      "compare_at": "Compare at {{price}} if billed monthly for 12 months",
      "start_date": "Start date",
      "end_date": "End date",
      "close": "Close",
      "subscribing": "Subscribing…",
      "subscribe": "Subscribe",
      "cancel_confirm_title": "Cancel Subscription?",
      "cancel_confirm_body": "Are you sure you want to cancel this subscription? You will lose access to the module features immediately.",
      "keep_it": "No, Keep it",
      "confirm_cancel": "Yes, Cancel"
    }
  },
  "guided_selling": {
    "page_title": "{{title}} | Guided Selling - Perfect Pairings",
    "index_page_title": "Guided Selling | Perfect Pairings",
    "eyebrow": "Guided Selling",
    "dish_fallback": "Dish",
    "dishes_stat_label": "Dishes",
    "pick_a_dish": "Pick a dish",
    "no_dishes_yet": "No dishes on this restaurant's menu yet.",
    "no_dishes_match": "No dishes match this search and filter.",
    "search_placeholder": "Search dishes…",
    "all_courses": "All",
    "more_filters": "More filters",
    "dishes_matching_one": "{{count}} of {{total}} dish",
    "dishes_matching_other": "{{count}} of {{total}} dishes",
    "recently_picked": "Recently picked",
    "just_now": "just now",
    "minutes_ago_one": "{{count}} min ago",
    "minutes_ago_other": "{{count}} min ago",
    "hours_ago_one": "{{count}}h ago",
    "hours_ago_other": "{{count}}h ago",
    "days_ago_one": "{{count}}d ago",
    "days_ago_other": "{{count}}d ago",
    "wines_scored_one": "{{count}} wine scored",
    "wines_scored_other": "{{count}} wines scored",
    "not_available": "N/A",
    "upsell_why_toggle": "Why?",
    "bottle_nudge": "From two glasses per person, the bottle is better value.",
    "house_pick": "House pick",
    "set_house_pick_prompt": "Set a house pick in dish settings",
    "suggested_pairings": "Suggested Pairings",
    "generating": "Generating suggestions for this dish — check back shortly.",
    "no_serving_format_glass": "This wine list has no glass wines yet.",
    "no_serving_format_bottle": "This wine list has no bottle wines yet.",
    "manage_wines_link": "Manage wines",
    "no_suitable_pairings": "No suitable wine pairings found for this dish in this view yet."
  },
  "wine_form": {
    "page_title": "{{title}} | Wine Atlas - Perfect Pairings",
    "wine_catalog": "Wine catalog",
    "back_to_wines": "← Back to wines",
    "add_wine": "Add Wine",
    "edit_wine": "Edit {{name}}",
    "save_wine": "Save Wine",
    "wine_fallback": "Wine",
    "enrich_error": "Could not enrich this wine.",
    "enriching": "Enriching…",
    "enrich_product": "✨ Enrich product",
    "saving": "Saving…",
    "section_identity": "Identity & Origin",
    "section_pricing": "Pricing & Availability",
    "section_tasting": "Tasting & Character",
    "section_profile": "Tasting Profile (1-5)",
    "section_producer": "Producer Details",
    "wine_name": "Wine Name *",
    "color": "Color *",
    "select_color": "Select a color…",
    "style": "Style",
    "style_none": "None",
    "grape_variety": "Grape Variety",
    "winery": "Winery",
    "vintage": "Vintage",
    "region": "Region",
    "country": "Country",
    "price_per_bottle": "Price per Bottle (€)",
    "price_per_glass": "Price per Glass (€)",
    "cost_per_bottle": "Cost per Bottle (€)",
    "cost_per_glass": "Cost per Glass (€)",
    "not_tracked": "Not tracked",
    "available_in_size": "Available in Size",
    "description": "Description",
    "tasting_notes": "Tasting Notes (comma separated)",
    "tasting_notes_placeholder": "Dark fruit, cedar, tobacco, violet",
    "winery_founded": "Winery Founded",
    "winery_founded_placeholder": "e.g. 1855",
    "estate_size": "Estate Size",
    "estate_size_placeholder": "e.g. 262 acres",
    "winery_location": "Winery Location",
    "about_winery": "About the Winery",
    "latitude": "Latitude",
    "longitude": "Longitude",
    "drink_from": "Drink From",
    "drink_until": "Drink Until",
    "bottle_placeholder": "Bottle Placeholder",
    "winery_banner_placeholder": "Winery Banner Placeholder",
    "remove_image": "Remove image",
    "no_placeholder_set": "No placeholder set",
    "upload": "Upload"
  },
  "wine_index": {
    "page_title": "Manage Wines | Wine Atlas - Perfect Pairings",
    "eyebrow": "Manage Wines",
    "total_wines": "Total Wines",
    "cost_price_filled": "Cost Price Filled",
    "cost_price_hint": "Needed for margin-based pairing suggestions",
    "hide_upload_panel": "Hide Upload Panel",
    "upload_wines": "Upload Wines",
    "upload_wine_list_file": "Upload wine list file",
    "drop_wine_list_here": "Drop your wine list here",
    "extract_hint": "We extract up to {{count}} wines per upload for review before import. CSV/Excel parse directly; PDF and images use AI (name required per row).",
    "choose_file": "Choose File",
    "selected_file": "Selected: {{name}}",
    "enrich_with_ai": "Enrich with AI",
    "uploading": "Uploading…",
    "upload_and_extract": "Upload & extract",
    "import_history": "Import History",
    "import_history_hint": "Status updates automatically while you stay on this page.",
    "no_imports_yet": "No imports yet.",
    "extracted_count": "Extracted: {{count}}",
    "invalid_count": "Invalid: {{count}}",
    "created_count": "Created: {{count}}",
    "skipped_count": "Skipped: {{count}}",
    "errors_count": "Errors: {{count}}",
    "queued_at": "Queued At: {{time}}",
    "started_at": "Started At: {{time}}",
    "finished_at": "Finished At: {{time}}",
    "enrichment_enriched": "Enrichment: {{count}} enriched",
    "enrichment_failed": ", {{count}} failed",
    "enrichment_in_progress": " — {{count}} still in progress…",
    "could_not_retry_failed": "Could not retry failed rows.",
    "retry_failed_rows_one": "Retry {{count}} failed row",
    "retry_failed_rows_other": "Retry {{count}} failed rows",
    "rows_truncated": "Only the first {{max}} wines were extracted.",
    "rows_truncated_with_total": "Only the first {{max}} wines were extracted ({{total}} found in file).",
    "sample_row_errors": "Sample row errors",
    "row_error": "Row {{row}}: {{messages}}",
    "loading": "Loading…",
    "review_wines_one": "Review {{count}} wine",
    "review_wines_other": "Review {{count}} wines",
    "download_invalid_rows_csv": "Download invalid rows CSV",
    "delete_run": "Delete run",
    "imports_still_running": "One or more imports are still running. Click Refresh to see latest status.",
    "wines_heading": "Wines ({{count}})",
    "wine_count_one": "{{count}} wine",
    "wine_count_other": "{{count}} wines",
    "search_wines": "Search wines...",
    "all_types": "All types",
    "delete_selected": "Delete Selected ({{count}})",
    "n_selected": "{{count}} selected",
    "no_wines_yet": "No wines yet. Add your first wine or upload a list.",
    "no_wines_match": "No wines match your current search/filter.",
    "pick_badge": "Pick",
    "edit_wine_aria": "Edit {{name}}",
    "delete_wine_aria": "Delete {{name}}",
    "details_wine_aria": "Details for {{name}}",
    "description_and_notes": "Description & Notes",
    "prev_page": "← Prev",
    "next_page": "Next →",
    "page_of": "Page {{page}} / {{pages}} ({{count}} total)",
    "per_page": "Per page",
    "import_started": "Import started. You will be notified when it finishes.",
    "confirm_delete_title": "Confirm delete",
    "confirm_delete_body": "Delete {{target}}? This action cannot be undone.",
    "confirm_delete_button": "Confirm delete",
    "deleting": "Deleting…",
    "could_not_load_review": "Could not load wines for review.",
    "all_wines_in_catalog_one": "{{count}} wine in your catalog",
    "all_wines_in_catalog_other": "{{count}} wines in your catalog",
    "selected_wines_one": "{{count}} selected wine",
    "selected_wines_other": "{{count}} selected wines"
  },
  "tag_input": {
    "remove_tag": "Remove {{tag}}"
  },
  "taste_slider": {
    "aria_label": "{{label}} {{score}} out of 5"
  },
  "dish_form": {
    "page_title": "{{title}} | Wine Atlas - Perfect Pairings",
    "dish_catalog": "Dish catalog",
    "back_to_dishes": "← Back to dishes",
    "add_dish": "Add Dish",
    "edit_dish": "Edit {{title}}",
    "save_dish": "Save Dish",
    "dish_fallback": "Dish",
    "enrich_error": "Could not enrich this dish.",
    "section_identity": "Identity",
    "section_pricing": "Pricing",
    "dish_name": "Dish Name *",
    "price": "Price (€)",
    "cost": "Cost (€)",
    "description": "Description",
    "highlights": "Highlights",
    "chefs_special": "Chef's special",
    "ingredients": "Ingredients",
    "ingredient_placeholder": "Type an ingredient, press Enter",
    "ingredient_placeholder_full": "e.g. chicken, garlic, thyme — press Enter after each",
    "item_image": "Item image",
    "item_image_hint": "Upload a high quality image to make this menu item stand out in the catalog.",
    "upload_image": "Upload Image",
    "choose_file": "Choose file",
    "no_file_selected": "No file selected",
    "menu_item_fallback": "Menu item",
    "no_image": "No image",
    "status": "Status",
    "status_active": "Active",
    "status_inactive": "Inactive",
    "house_pick_hint": "The sommelier's manual wine recommendation for this dish, shown above the guided-selling ladder.",
    "wine_to_feature": "Wine to feature",
    "no_house_pick": "— No house pick —",
    "why_optional": "Why (optional)",
    "house_pick_note_placeholder": "Without your own text this falls back to the AI explanation for this wine."
  },
  "dish_index": {
    "page_title": "Manage Dishes | Wine Atlas - Perfect Pairings",
    "eyebrow": "Manage Dishes",
    "total_dishes": "Total Dishes",
    "upload_dishes": "Upload Dishes",
    "upload_dish_list_file": "Upload dish list file",
    "drop_menu_here": "Drop your menu here",
    "extract_hint": "We extract up to {{count}} dishes per upload for review before import. CSV/Excel parse directly; PDF and images use AI (name required per row).",
    "rows_truncated": "Only the first {{max}} dishes were extracted.",
    "rows_truncated_with_total": "Only the first {{max}} dishes were extracted ({{total}} found in file).",
    "review_dishes_one": "Review {{count}} dish",
    "review_dishes_other": "Review {{count}} dishes",
    "imports_still_running": "One or more imports are still running. Status refreshes automatically.",
    "dishes_heading": "Dishes ({{count}})",
    "dishes_heading_count_one": "{{count}} dish",
    "dishes_heading_count_other": "{{count}} dishes",
    "search_dishes": "Search dishes...",
    "all_courses": "All courses",
    "no_description_yet": "No description yet.",
    "no_dishes_yet": "No dishes yet. Add your first dish or upload a menu.",
    "no_dishes_match": "No dishes match your current search/filter.",
    "could_not_load_review": "Could not load dishes for review.",
    "all_dishes_in_catalog_one": "all {{count}} dish",
    "all_dishes_in_catalog_other": "all {{count}} dishes in your catalog"
  },
  "import_review": {
    "wine_name_blank": "Wine Name can't be blank",
    "winery_blank": "Winery can't be blank",
    "color_missing": "Color is not included in the list",
    "dish_name_blank": "Dish name can't be blank",
    "untitled_wine": "Untitled wine",
    "untitled_dish": "Untitled dish",
    "invalid": "Invalid",
    "invalid_with_count": "Invalid ({{count}})",
    "new_badge": "New",
    "already_on_card": "Already on card",
    "price_changed_title": "{{size}} price changed",
    "price_changed": "Price changed",
    "remove_wine": "Remove {{name}}",
    "remove_dish": "Remove {{name}}",
    "wine_count_one": "{{count}} wine",
    "wine_count_other": "{{count}} wines",
    "dish_count_one": "{{count}} dish",
    "dish_count_other": "{{count}} dishes",
    "gone": "Gone",
    "keep": "Keep",
    "remove": "Remove",
    "add": "Add",
    "skip": "Skip",
    "update": "Update",
    "update_prices": "Update prices",
    "removed_when_finished": "Removed from your card when the import finishes.",
    "removed_from_menu_when_finished": "Removed from your menu when the import finishes.",
    "nothing_selected": "Nothing selected to import.",
    "import_failed": "Import failed.",
    "network_error_wines": "Network error while importing wines.",
    "network_error_dishes": "Network error while importing dishes.",
    "wine_validation_title": "Wine List Validation",
    "wine_validation_subtitle": "Review, categorize and validate extracted wines from menu.",
    "menu_validation_title": "Menu Validation",
    "menu_validation_subtitle": "Review, categorize and validate extracted dishes from your menu.",
    "showing_first": "· Showing first {{count}}",
    "showing_first_of_total": "· Showing first {{count}} of {{total}} found",
    "extracted_wines": "Extracted Wines",
    "extracted_dishes": "Extracted Dishes",
    "all": "All",
    "no_invalid_wines": "No invalid wines in this list.",
    "no_wines_to_review": "No wines to review.",
    "no_invalid_dishes": "No invalid dishes in this list.",
    "no_dishes_to_review": "No dishes to review.",
    "edit_wine_details": "Edit Wine Details",
    "edit_dish_details": "Edit Dish Details",
    "enrich_with_ai": "Enrich with AI",
    "select_wine_to_edit": "Select a wine from the list to edit its details.",
    "select_dish_to_edit": "Select a dish from the list to edit its details.",
    "wines_ready_to_import_one": "{{count}} wine ready to import",
    "wines_ready_to_import_other": "{{count}} wines ready to import",
    "dishes_ready_to_import_one": "{{count}} dish ready to import",
    "dishes_ready_to_import_other": "{{count}} dishes ready to import",
    "marked_invalid_suffix": " · {{count}} marked invalid",
    "to_remove_suffix": " · {{count}} to remove from your card",
    "to_remove_from_menu_suffix": " · {{count}} to remove from your menu",
    "starting_import": "Starting import…",
    "finalize_wine_import": "Finalize Wine Import",
    "finalize_menu_import": "Finalize Menu Import"
  },
  "location_edit": {
    "create_page_title": "Create Your Restaurant | Perfect Pairings",
    "create_heading": "Create Your Restaurant",
    "edit_heading": "Edit Restaurant Details",
    "back_to_restaurant_admin": "← Back to restaurant admin",
    "digital_sommelier": "Digital sommelier"
  },
  "subscription_page": {
    "page_title": "Module subscriptions | Perfect Pairings",
    "billing": "Billing",
    "module_subscriptions": "Module Subscriptions",
    "access_required": "Access Required",
    "access_required_body": "You don't currently have the access to this module. Request a subscription for this module.",
    "sending_request": "Sending Request…",
    "send_pending_invite": "Send Pending Invite"
  },
  "wine_tile_view": {
    "page_title": "Wines | Wine Atlas - Perfect Pairings",
    "search_placeholder": "Start typing: Rioja, Chardonnay, Sommelier...",
    "search": "Search",
    "reset": "Reset",
    "filtered_count": "{{shown}} of {{total}} on this page ({{count}} total)",
    "page_of": "Page {{page}} / {{pages}}",
    "no_wines_on_page_match": "No wines on this page match your filters.",
    "no_wines_match_search": "No wines match your search.",
    "clear_filters": "Clear filters"
  },
  "dish_tile_view": {
    "page_title": "Dishes | Wine Atlas - Perfect Pairings",
    "search_placeholder": "Search menu items...",
    "no_menu_items_match": "No menu items match your filters."
  }
}
